/* Links page: Instagram Cover Flow (Instafeed Feed API), caption link-outs, UTM tags, vCard, click wheel. */
(function () {
  'use strict';
  var root = document.querySelector('[data-links]');
  var cfgEl = document.querySelector('[data-links-config]');
  if (!root || !cfgEl) return;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* ---------- helpers ---------- */
  function track(name, detail) {
    detail = detail || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('links_' + name, detail); } catch (e) {}
    try { if (window.gtag) window.gtag('event', 'links_' + name, detail); } catch (e) {}
  }
  function tagUrl(href) {
    if (!cfg.utm || !href || /^(mailto:|tel:|#)/.test(href)) return href;
    try {
      var u = new URL(href, location.origin);
      // Tag only owned destinations off this site (Substack). Internal links keep the visit's original source.
      if (!/substack\.com$/.test(u.host)) return href;
      cfg.utm.split('&').forEach(function (pair) {
        var kv = pair.split('='); if (kv[0] && !u.searchParams.has(kv[0])) u.searchParams.set(kv[0], decodeURIComponent(kv[1] || ''));
      });
      return u.toString();
    } catch (e) { return href; }
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  root.querySelectorAll('[data-utm]').forEach(function (a) { a.href = tagUrl(a.getAttribute('href')); });
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-track]'); if (!a) return;
    track(a.getAttribute('data-track'), { label: a.getAttribute('data-label') || a.textContent.trim().slice(0, 60), href: a.href || '' });
  });

  /* ---------- vCard (contact card with photo, email and links) ---------- */
  function vEsc(t) { return String(t).replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/([,;])/g, '\\$1'); }
  function photoB64(src) {
    return new Promise(function (resolve) {
      if (!src) return resolve('');
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var c = document.createElement('canvas'); c.width = c.height = 400;
          var s = Math.min(img.naturalWidth, img.naturalHeight);
          c.getContext('2d').drawImage(img, (img.naturalWidth - s) / 2, (img.naturalHeight - s) / 2, s, s, 0, 0, 400, 400);
          resolve(c.toDataURL('image/jpeg', 0.85).split(',')[1]);
        } catch (e) { resolve(''); }
      };
      img.onerror = function () { resolve(''); };
      img.src = src;
      setTimeout(function () { resolve(''); }, 2500);
    });
  }
  var vbtn = root.querySelector('[data-vcard]');
  if (vbtn) vbtn.addEventListener('click', function () {
    var v = cfg.vcard || {};
    var name = v.name || 'Tony Lee', parts = name.split(' ');
    photoB64(v.photo).then(function (b64) {
      var L = ['BEGIN:VCARD', 'VERSION:3.0', 'N:' + vEsc(parts.slice(1).join(' ')) + ';' + vEsc(parts[0]) + ';;;', 'FN:' + vEsc(name)];
      if (v.title) L.push('TITLE:' + vEsc(v.title));
      if (v.email) L.push('EMAIL;TYPE=INTERNET,pref:' + v.email);
      var urls = [['Website', v.url], ['LinkedIn', v.linkedin], ['Instagram', v.instagram], ['Substack', v.substack], ['X', v.x], ['Threads', v.threads], ['YouTube', v.youtube]];
      var n = 0;
      urls.forEach(function (u) { if (!u[1]) return; n++; L.push('item' + n + '.URL' + (n === 1 ? ';type=pref' : '') + ':' + u[1]); L.push('item' + n + '.X-ABLabel:' + u[0]); });
      if (v.linkedin) L.push('X-SOCIALPROFILE;type=linkedin:' + v.linkedin);
      if (v.instagram) L.push('X-SOCIALPROFILE;type=instagram;x-user=sheckii:' + v.instagram);
      if (v.x) L.push('X-SOCIALPROFILE;type=twitter;x-user=sheckii:' + v.x);
      if (v.note) L.push('NOTE:' + vEsc(v.note));
      if (b64) L.push('PHOTO;ENCODING=b;TYPE=JPEG:' + b64);
      L.push('END:VCARD');
      var fold = function (l) { var o = ''; while (l.length > 75) { o += l.slice(0, 75) + '\r\n '; l = l.slice(75); } return o + l; };
      var blob = new Blob([L.map(fold).join('\r\n') + '\r\n'], { type: 'text/vcard;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob); a.download = name.replace(/\s+/g, '-') + '.vcf';
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
      vbtn.classList.add('is-done');
    });
  });

  /* ---------- Feed ---------- */
  var flow = root.querySelector('[data-flow]');
  var stage = root.querySelector('[data-stage]');
  var now = { count: root.querySelector('[data-now-count]'), date: root.querySelector('[data-now-date]'), caption: root.querySelector('[data-now-caption]'), link: root.querySelector('[data-now-link]') };
  var posts = [], covers = [], index = 0;

  function shortcode(link) { var m = String(link || '').match(/\/(?:p|reel|tv)\/([\w-]+)/); return m ? m[1] : ''; }
  var hidden = (cfg.hide || '').split(/\s+/).map(shortcode).filter(Boolean);

  // A post links out when its caption ends with a line like "🔗 sheckii.com/speaking".
  // Links in captions: a line starting with the link emoji wins; otherwise the last web address
  // anywhere in the caption (e.g. "sheckii.com" or "https://sheckii.substack.com/p/flier-lies").
  // Emails and @handles are ignored. A link that sits on its own line is dropped from the caption text.
  var LINK_RE = /🔗️?\s*:?\s*((?:https?:\/\/)?(?:[\w-]+\.)+[a-z]{2,}(?:\/[^\s]*)?)/i;
  var URL_RE = /(^|[^\w@.\/-])((?:https?:\/\/)?(?:www\.)?(?:[a-z0-9-]+\.)+(?:com|co|io|net|org|me|fm|ai|ly|app|tv|us|xyz|link|page|so|gg|dev|shop|store|news|blog|studio|bio)(?::\d+)?(?:\/[^\s]*)?)/gi;
  function trimUrl(u) { return u.replace(/[)\].,!?:;'"’”]+$/, ''); }
  function findLink(lines) {
    for (var i = lines.length - 1; i >= 0 && i >= lines.length - 3; i--) {
      var m = lines[i].match(LINK_RE);
      if (m) return { url: trimUrl(m[1]), line: i };
    }
    for (var j = lines.length - 1; j >= 0; j--) {
      var found = null, mm; URL_RE.lastIndex = 0;
      while ((mm = URL_RE.exec(lines[j]))) found = trimUrl(mm[2]);
      if (found && !/(^|\.)instagram\.com/i.test(found)) {
        var alone = lines[j].trim().replace(/[.!]+$/, '') === found || lines[j].trim() === found;
        return { url: found, line: alone ? j : -1 };
      }
    }
    return null;
  }
  function parse(p) {
    var text = (p.caption && p.caption.text) || '';
    var lines = text.split('\n'), link = '';
    var hit = findLink(lines);
    if (hit) { link = hit.url; if (hit.line > -1) lines.splice(hit.line, 1); }
    var clean = lines.join(' ').replace(/\s+/g, ' ').trim();
    if (link && !/^https?:\/\//i.test(link)) link = 'https://' + link;
    var pretty = link ? link.replace(/^https?:\/\/(www\.)?/i, '').replace(/\/$/, '') : '';
    return {
      id: p.id, img: p.images && p.images.standard_resolution && p.images.standard_resolution.url,
      type: p.type, time: p.created_time, permalink: p.link, caption: clean,
      link: link ? tagUrl(link) : '', pretty: pretty
    };
  }

  function fmtDate(ts) {
    try { return new Date(ts * 1000).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); } catch (e) { return ''; }
  }

  function render() {
    stage.innerHTML = '';
    covers = posts.map(function (p, i) {
      var el = document.createElement('div');
      el.className = 'lk-cover' + (p.link ? ' is-link' : '');
      el.setAttribute('role', 'option');
      el.setAttribute('aria-label', (p.caption || 'Instagram post').slice(0, 80));
      var badge = p.type === 'video' ? '▶' : p.type === 'carousel_album' ? '❐' : '';
      el.innerHTML = '<div class="lk-cover__img"><img alt="" decoding="async" ' + (i < 5 ? '' : 'loading="lazy" ') + 'src="' + esc(p.img) + '"></div>' +
        '<span class="lk-cover__shade"></span>' +
        (p.link ? '<span class="lk-cover__badge lk-cover__badge--link" aria-hidden="true">🔗</span>' : '') +
        (badge ? '<span class="lk-cover__badge" aria-hidden="true">' + badge + '</span>' : '');
      el.addEventListener('click', function () { if (moved) return; if (i === index) openCurrent(); else go(i); });
      stage.appendChild(el);
      return el;
    });
    layout();
  }

  function layout() {
    var cov = parseFloat(getComputedStyle(root).getPropertyValue('--cov')) || 200;
    covers.forEach(function (el, i) {
      var d = i - index, a = Math.abs(d), s = d < 0 ? -1 : 1, t;
      if (d === 0) t = 'translate3d(0,0,' + cov * 0.18 + 'px)';
      else t = 'translate3d(' + s * (cov * 0.68 + (a - 1) * cov * 0.22) + 'px,0,' + (-cov * 0.42) + 'px) rotateY(' + (-s * 64) + 'deg)';
      el.style.transform = t;
      el.style.zIndex = String(100 - a);
      el.style.opacity = a > 5 ? '0' : '1';
      el.style.setProperty('--shade', d === 0 ? '0' : String(Math.min(0.15 + a * 0.12, 0.7)));
      el.setAttribute('aria-selected', d === 0 ? 'true' : 'false');
    });
    var p = posts[index]; if (!p) return;
    now.count.textContent = (index + 1) + ' of ' + posts.length;
    now.date.textContent = fmtDate(p.time);
    now.caption.textContent = p.caption || 'Untitled post';
    if (p.link) { now.link.href = p.link; now.link.innerHTML = esc(p.pretty) + '<span aria-hidden="true">→</span>'; now.link.classList.add('is-link'); }
    else { now.link.href = p.permalink; now.link.innerHTML = 'View on Instagram<span aria-hidden="true">↗</span>'; now.link.classList.remove('is-link'); }
  }

  function go(i) { if (!posts.length) return; index = Math.max(0, Math.min(posts.length - 1, i)); layout(); }
  function step(n) { go(index + n); }
  function openCurrent() {
    var p = posts[index]; if (!p) return;
    track(p.link ? 'post_link' : 'post_instagram', { post: shortcode(p.permalink), href: p.link || p.permalink });
    window.location.href = p.link || p.permalink;
  }
  now.link.addEventListener('click', function () { var p = posts[index]; if (p) track(p.link ? 'post_link' : 'post_instagram', { post: shortcode(p.permalink), href: now.link.href }); });
  root.querySelector('[data-prev]').addEventListener('click', function () { step(-1); });
  root.querySelector('[data-next]').addEventListener('click', function () { step(1); });

  stage.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { step(1); e.preventDefault(); }
    else if (e.key === 'ArrowLeft') { step(-1); e.preventDefault(); }
    else if (e.key === 'Home') { go(0); e.preventDefault(); }
    else if (e.key === 'End') { go(posts.length - 1); e.preventDefault(); }
    else if (e.key === 'Enter') { openCurrent(); }
  });

  // Drag / swipe
  var dragX = null, dragStart = 0, moved = false;
  stage.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    dragX = e.clientX; dragStart = index; moved = false;
  });
  window.addEventListener('pointermove', function (e) {
    if (dragX === null) return;
    var dx = e.clientX - dragX;
    if (Math.abs(dx) > 6) { moved = true; stage.classList.add('is-dragging'); }
    var cov = parseFloat(getComputedStyle(root).getPropertyValue('--cov')) || 200;
    var target = dragStart - Math.round(dx / (cov * 0.34));
    if (target !== index) go(target);
  });
  window.addEventListener('pointerup', function () {
    if (dragX === null) return;
    dragX = null; stage.classList.remove('is-dragging');
    setTimeout(function () { moved = false; }, 0);
  });
  // Trackpad horizontal scroll
  var wheelAcc = 0, wheelT = 0;
  stage.addEventListener('wheel', function (e) {
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    e.preventDefault();
    wheelAcc += e.deltaX;
    var now2 = Date.now();
    if (Math.abs(wheelAcc) > 60 && now2 - wheelT > 120) { step(wheelAcc > 0 ? 1 : -1); wheelAcc = 0; wheelT = now2; }
  }, { passive: false });
  window.addEventListener('resize', function () { layout(); });

  /* ---------- Click wheel ---------- */
  var wheel = root.querySelector('[data-wheel]');
  var autoplay = null;
  if (wheel) {
    var ring = wheel.querySelector('.lk-wheel__ring');
    var lastAng = null, acc = 0;
    function angle(e) { var r = ring.getBoundingClientRect(); return Math.atan2(e.clientY - (r.top + r.height / 2), e.clientX - (r.left + r.width / 2)) * 180 / Math.PI; }
    ring.addEventListener('pointerdown', function (e) {
      if (e.target.closest('[data-wheel-center],.lk-wheel__label')) return;
      lastAng = angle(e); acc = 0; ring.classList.add('is-spinning'); ring.setPointerCapture(e.pointerId);
    });
    ring.addEventListener('pointermove', function (e) {
      if (lastAng === null) return;
      var a = angle(e), d = a - lastAng;
      if (d > 180) d -= 360; if (d < -180) d += 360;
      acc += d; lastAng = a;
      while (acc > 28) { step(1); acc -= 28; }
      while (acc < -28) { step(-1); acc += 28; }
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) { ring.addEventListener(ev, function () { lastAng = null; ring.classList.remove('is-spinning'); }); });
    wheel.querySelector('[data-wheel-prev]').addEventListener('click', function () { step(-1); });
    wheel.querySelector('[data-wheel-next]').addEventListener('click', function () { step(1); });
    wheel.querySelector('[data-wheel-center]').addEventListener('click', function () { track('wheel_select'); openCurrent(); });
    wheel.querySelector('[data-wheel-menu]').addEventListener('click', function () { track('wheel_menu'); window.open(cfg.profile, '_blank', 'noopener'); });
    wheel.querySelector('[data-wheel-play]').addEventListener('click', function () {
      if (autoplay) { clearInterval(autoplay); autoplay = null; return; }
      autoplay = setInterval(function () { go(index + 1 >= posts.length ? 0 : index + 1); }, 3200);
    });
  }

  function fail() {
    stage.innerHTML = '';
    flow.classList.add('is-empty');
    now.count.textContent = '';
    now.caption.textContent = 'The latest posts are on Instagram.';
    now.link.href = cfg.profile;
    root.querySelectorAll('[data-prev],[data-next]').forEach(function (b) { b.hidden = true; });
    stage.style.display = 'none';
  }

  function load() {
    if (!cfg.key || !cfg.endpoint) return fail();
    var cacheKey = 'lk-feed:' + cfg.account;
    try {
      var c = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (c && Date.now() - c.t < 5 * 60 * 1000 && c.data && c.data.length) return use(c.data);
    } catch (e) {}
    var want = (cfg.count || 12) + hidden.length;
    var url = cfg.endpoint + '?limit=' + want + '&account=' + encodeURIComponent(cfg.account) + '&fu=0&fid=0&v=' + Math.floor(Date.now() / 600000);
    fetch(url, { headers: { 'X-API-Key': cfg.key } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.data || !j.data.length) throw new Error('feed ' + (j && j.meta && j.meta.code));
        try { sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), data: j.data })); } catch (e) {}
        use(j.data);
      })
      .catch(function (e) { if (window.console) console.warn('[links] feed unavailable', e); fail(); });
  }
  function use(data) {
    posts = data.filter(function (p) { return hidden.indexOf(shortcode(p.link)) === -1; }).slice(0, cfg.count || 12).map(parse).filter(function (p) { return p.img; });
    if (!posts.length) return fail();
    index = 0;
    render();
  }
  load();
})();
